<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="durations" :action="{'text':'add Duration','url':route('academic.duration.create')}" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Duration')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Duration')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Duration')" :href="route('academic.duration.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink
        },
        props:['durations'],
        data(){
            return{
                fields:[{'key':'start_month','label':'Start Month'},{'key':'end_month','label':'End Month'},{'key':'code','label':'Code'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
